import authService from "api/authService"
import { useMutation } from "react-query"
import { ICheckAuthorizeByPhoneBody } from "./authMutationsTypes"

const useCheckAuthorizeByPhoneMutation = () => {
  return useMutation(
    async (data: ICheckAuthorizeByPhoneBody) => {
      const res = await authService.checkAuthorizeByPhone(data)

      return res.data
    },
    { mutationKey: "checkAuthorizeByPhone" },
  )
}

export default useCheckAuthorizeByPhoneMutation
